import * as React from 'react';
import PhoneInput from 'react-phone-number-input/input';

import { useSurvey } from '@src/hooks/useSurvey';
import { SurveyQuestionProps } from './SurveyQuestion';

export interface TypePhoneProps extends SurveyQuestionProps {}

/**
 * @name TypePhone
 * @description Collect some phone information from the survey
 */
export const TypePhone = (props: TypePhoneProps) => {
  const { question } = props;

  // Hooks
  const { answers, setAnswer } = useSurvey();
  const value = answers[question.name];

  // Setup
  const { placeholder, properties = {}, required = false } = question; // prettier-ignore
  const { autocomplete } = properties;

  // Handlers
  const onChange = (value?: string) => {
    setAnswer(question.name, value);
  };

  return (
    <PhoneInput
      autoComplete={autocomplete}
      className="m-0 rounded-none border-0 p-3 font-beatrice-light text-14 md:px-8 md:pt-4 md:text-18"
      country="US"
      name={question.name}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      type="text"
      value={value}
    />
  );
};
